import { Component, OnInit, Input } from '@angular/core';
import { Globals } from '../../../globals';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-asidebar-right',
    templateUrl: './asidebar-right.component.html',
    styleUrls: ['./asidebar-right.component.css']
})
export class AsidebarRightComponent implements OnInit {
    @Input('hidden') hidden: any
    public token: any = {
        getlibrarylimit: "api/getLibraryLimitByType",
        getBannerAds: "api/getBannerAds",
        getDanhmucContent: "api/getDanhmucContent",
    }
    public bannerAds = [];
    public dataDM: any
    public connect;
    public library = { videoright: [] };
    constructor(
        public globals: Globals, public sanitizer: DomSanitizer, public route: ActivatedRoute,
    ) {
        this.connect = this.globals.result.subscribe((res: any) => {
            switch (res.token) {
                case "getlibraryvideolimit4":
                    if (res.data.length > 0) {
                        this.library.videoright = res.data;
                        this.library.videoright.reduce((n, o, i) => {
                            o.value = (o.type == 2) ? this.sanitizer.bypassSecurityTrustResourceUrl(o.value.replace('watch?v=', 'embed/')) : o.value;
                            return n;
                        }, []);
                    }
                    break;
                case "getDanhmucContent":
                    this.dataDM = res.data;
                    break;
                case "getBannerAds":
                    this.bannerAds = res.data;
                    break;
                default:
                    break;
            }
        });
    }

    ngOnInit() {
        this.globals.send({ path: this.token.getDanhmucContent, token: "getDanhmucContent" });
        this.globals.send({ path: this.token.getlibrarylimit, token: "getlibraryvideolimit4", params: { type: 2, limit: 4 } });
        this.globals.send({ path: this.token.getBannerAds, token: "getBannerAds" });
    }
    ngOnDestroy() {
        this.connect.unsubscribe();
    }

}



// WEBPACK FOOTER //
// ./src/app/frontend/modules/asidebar-right/asidebar-right.component.ts